"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * Project/App Name APIs
 * API documentation for the backend services of Project/App Name
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaymentReceiptDto = instanceOfPaymentReceiptDto;
exports.PaymentReceiptDtoFromJSON = PaymentReceiptDtoFromJSON;
exports.PaymentReceiptDtoFromJSONTyped = PaymentReceiptDtoFromJSONTyped;
exports.PaymentReceiptDtoToJSON = PaymentReceiptDtoToJSON;
exports.PaymentReceiptDtoToJSONTyped = PaymentReceiptDtoToJSONTyped;
/**
 * Check if a given object implements the PaymentReceiptDto interface.
 */
function instanceOfPaymentReceiptDto(value) {
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('depositAmount' in value) || value['depositAmount'] === undefined)
        return false;
    if (!('totalPaid' in value) || value['totalPaid'] === undefined)
        return false;
    if (!('status' in value) || value['status'] === undefined)
        return false;
    return true;
}
function PaymentReceiptDtoFromJSON(json) {
    return PaymentReceiptDtoFromJSONTyped(json, false);
}
function PaymentReceiptDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'id': json['id'],
        'depositAmount': json['depositAmount'],
        'totalPaid': json['totalPaid'],
        'status': json['status'],
        'uploadedAt': json['uploadedAt'] == null ? undefined : json['uploadedAt'],
    };
}
function PaymentReceiptDtoToJSON(json) {
    return PaymentReceiptDtoToJSONTyped(json, false);
}
function PaymentReceiptDtoToJSONTyped(value, ignoreDiscriminator) {
    if (ignoreDiscriminator === void 0) { ignoreDiscriminator = false; }
    if (value == null) {
        return value;
    }
    return {
        'id': value['id'],
        'depositAmount': value['depositAmount'],
        'totalPaid': value['totalPaid'],
        'status': value['status'],
        'uploadedAt': value['uploadedAt'],
    };
}
